import ObjectMapController from "./object_map_controller"

export default class ExchangeMarketSalesMapController extends ObjectMapController {
  static values = {
    ...ObjectMapController.values,
    subjectType: "sale",
    parentSubjectType: "market",
  }
}
